import React from "react";

import SharedEmptyState from "../../../components/EmptyState";

/**
 * Empty State Component
 * Shown when no participants exist in current tab
 * Matches Figma design exactly with organic blob background
 */
const EmptyState = () => {
  return (
    <SharedEmptyState
      illustration={<MembersIllustration />}
      heading="There is no information about teams"
      description="Start by adding a participant to the competition by clicking Add."
      className="pt-6"
    />
  );
};

/**
 * Blob illustration with participant card placeholders (from Figma)
 */
const MembersIllustration = () => {
  const scale = 0.75;

  return (
    <div className="relative" style={{ width: `${360.902 * scale}px`, height: `${400 * scale}px` }}>
      {/* Background blob shape */}
      <svg
        className="absolute inset-0"
        width={360.902 * scale}
        height={400 * scale}
        viewBox="0 0 360 400"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid meet"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M196.179 0.0753154C249.628 -2.10609 296.959 43.4709 322.698 88.3711C344.702 126.757 312.916 173.274 320.241 216.496C325.786 249.219 358.411 272.78 359.563 305.912C361.061 348.985 359.563 351.455 320.241 385.68C285.996 411.542 242.013 397.286 196.179 385.68C166.409 378.141 135.126 384.707 107.124 372.438C73.6386 357.767 39.7599 340.129 21.8758 309.309C1.9268 274.931 -5.602 233.575 4.41351 195.435C14.8131 155.832 48.0527 128.145 77.2626 98.3881C114.028 60.9333 142.542 2.26443 196.179 0.0753154Z"
          fill="#081725"
        />
      </svg>

      {/* Card illustration */}
      <div
        className="absolute flex flex-col z-10"
        style={{
          left: `${71 * scale}px`,
          top: `calc(50% + ${0.15 * scale}px)`,
          transform: "translateY(-50%)",
          width: `${218 * scale}px`,
          height: `${314.304 * scale}px`,
          gap: `${5 * scale}px`,
        }}
      >
        {/* Upper header card */}
        <div
          className="flex flex-col items-start w-full"
          style={{
            paddingLeft: `${16 * scale}px`,
            paddingRight: `${16 * scale}px`,
            paddingTop: `${12 * scale}px`,
            paddingBottom: `${12 * scale}px`,
            background: "#26333D",
            borderRadius: `${12 * scale}px`,
          }}
        >
          <div className="flex items-center w-full" style={{ gap: `${8.721 * scale}px` }}>
            <div
              className="shrink-0 rounded-full"
              style={{
                width: `${32 * scale}px`,
                height: `${32 * scale}px`,
                background: "#E5E5D6",
              }}
            />
            <div className="flex flex-col flex-1" style={{ gap: `${8.721 * scale}px` }}>
              <div
                style={{
                  width: `${45.777 * scale}px`,
                  height: `${8.583 * scale}px`,
                  background: "#4C565D",
                  borderRadius: `${1429.09 * scale}px`,
                }}
              />
              <div
                style={{
                  width: `${98.451 * scale}px`,
                  height: `${8.583 * scale}px`,
                  background: "#E5E5D6",
                  borderRadius: `${1429.09 * scale}px`,
                }}
              />
            </div>
          </div>
        </div>

        {/* Lower list card */}
        <div
          className="flex flex-col w-full"
          style={{
            padding: `${10.561 * scale}px`,
            background: "#989D99",
            borderRadius: `${10.561 * scale}px`,
            gap: `${10.561 * scale}px`,
          }}
        >
          {[...Array(10)].map((_, i) => (
            <div
              key={i}
              className="flex items-center w-full"
              style={{ gap: `${3.96 * scale}px` }}
            >
              <div
                className="shrink-0 rounded-full"
                style={{
                  width: `${15.842 * scale}px`,
                  height: `${15.842 * scale}px`,
                  background: "#E5E5D6",
                }}
              />
              <div className="flex flex-col flex-1" style={{ gap: `${3.96 * scale}px` }}>
                <div
                  style={{
                    width: `${31.683 * scale}px`,
                    height: `${5.941 * scale}px`,
                    background: "#4C565D",
                    borderRadius: `${989.109 * scale}px`,
                  }}
                />
                <div
                  style={{
                    width: "100%",
                    height: `${5.941 * scale}px`,
                    background: "#E5E5D6",
                    borderRadius: `${989.109 * scale}px`,
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EmptyState;
